export default __webpack_public_path__ + "static/logo-b2839c1b10fdbf866673263e3b17d02d.jpg";